import React, { useState } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Link } from "react-router-dom";

import logo from "../assets/img/LogoFree.svg";
import "../assets/css/cs.css";

const meta = {
  title: "Shipping & Exchange - Logy.AI",
  meta: [],
  link: [],
  style: [],
  script: [],
};

export default function ShippingExchange() {
  const [menu, setMenu] = useState(true);
  const toggleMenu = () => {
    setMenu(!menu);
  };
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <section className="pt-6 bg-gray-50 overflow-hidden pb-6">
        <div className="container mx-auto px-4">
          <div className="mb-1">
            <div className="flex items-center justify-between px-6 py-3.5 bg-white border border-gray-100 rounded-full">
              <div className="w-auto">
                <div className="flex flex-wrap items-center">
                  <div className="w-auto">
                    <Link className="inline-block" to="/">
                      <img
                        src={logo}
                        style={{
                          width: "100px",
                          transform: "translateY(3px) translateX(10px)",
                        }}
                        alt=""
                      />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="w-auto">
                <div className="flex flex-wrap items-center">
                  <div className="w-auto hidden lg:block">
                    <ul className="flex items-center justify-center ">
                      <li className="  ">
                        <Link
                          to="/about"
                          className="inline-block px-3 py-4 text-black text-md text-center font-medium hover:underline hover:text-purple-500"
                        >
                          About Us
                        </Link>
                      </li>
                      <li className="  ">
                        <Link
                          to="/products"
                          className="inline-block px-3 py-4 text-black text-md text-center font-medium hover:underline hover:text-purple-500"
                        >
                          Products
                        </Link>
                      </li>
                      <li className="  ">
                        <Link
                          to="/articles"
                          className="inline-block px-3 py-4 text-black text-md text-center font-medium hover:underline hover:text-purple-500"
                        >
                          Articles
                        </Link>
                      </li>
                      <li className="  ">
                        <Link
                          to="/cases"
                          className="inline-block px-3 py-4 text-black text-md text-center font-medium hover:underline hover:text-purple-500"
                        >
                          Case Studies
                        </Link>
                      </li>
                      <li className="mr-9   ">
                        <Link
                          to="/contact"
                          className="inline-block px-3 py-4 text-black text-md text-center font-medium hover:underline hover:text-purple-500"
                        >
                          Contact Us
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="w-auto lg:hidden">
                    <button
                      className="inline-block"
                      onClick={() => toggleMenu()}
                    >
                      <svg
                        className="navbar-burger text-gray-800"
                        width={45}
                        height={45}
                        viewBox="0 0 56 56"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          width={56}
                          height={56}
                          rx={28}
                          fill="currentColor"
                        />
                        <path
                          d="M37 32H19M37 24H19"
                          stroke="white"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`${menu ? "hidden" : ""} navbar-menu fixed top-0 left-0 bottom-0 w-4/6 sm:max-w-xs z-50`}
            >
              <div className="navbar-backdrop fixed inset-0 bg-gray-800 opacity-80" />
              <nav className="relative z-10 px-9 py-8 bg-white h-full overflow-y-auto">
                <div className="flex flex-wrap justify-between h-full">
                  <div className="w-full">
                    <div className="flex items-center justify-between -m-2">
                      <div className="w-auto p-2">
                        <Link className="inline-block" to="/">
                          <img
                            src={logo}
                            style={{ width: "100px" }}
                            alt=""
                          />
                        </Link>
                      </div>
                      <div className="w-auto p-2">
                        <button
                          className="inline-block navbar-burger"
                          onClick={() => toggleMenu()}
                        >
                          <svg
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6 18L18 6M6 6L18 18"
                              stroke="#111827"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col justify-center py-8 w-full">
                    <ul>
                      <li className="mb-12">
                        <Link
                          to="/about"
                          className="font-heading font-medium text-lg text-gray-900 hover:text-gray-700"
                        >
                          About Us
                        </Link>
                      </li>
                      <li className="mb-12">
                        <Link
                          to="/products"
                          className="font-heading font-medium text-lg text-gray-900 hover:text-gray-700"
                        >
                          Products
                        </Link>
                      </li>
                      <li className="mb-12">
                        <Link
                          to="/articles"
                          className="font-heading font-medium text-lg text-gray-900 hover:text-gray-700"
                        >
                          Articles
                        </Link>
                      </li>
                      <li className="mb-12">
                        <Link
                          to="/cases"
                          className="font-heading font-medium text-lg text-gray-900 hover:text-gray-700"
                        >
                          Case Studies
                        </Link>
                      </li>
                      <li className="mb-12">
                        <Link
                          to="/contact"
                          className="font-heading font-medium text-lg text-gray-900 hover:text-gray-700"
                        >
                          Contact Us
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </section>

      <div className="container mx-auto mt-8 px-4 pb-16">
        <div className="flex justify-center pt-10">
          <div className="max-w-4xl bg-white p-8 rounded-lg">
            <h1 className="text-5xl font-bold mb-8 text-center text-gray-900">
              Shipping & Exchange Policy
            </h1>
            
            <p className="text-gray-600 text-lg mb-8">
              Effective Date: January 1, 2024
            </p>

            <div className="space-y-8">
              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-900">1. Nature of Our Products</h2>
                <p className="text-gray-700 leading-relaxed">
                  Logy.AI provides cloud-based software solutions and digital services for healthcare organizations. As a software-as-a-service (SaaS) provider, we do not ship physical products. All our solutions are delivered digitally through secure cloud infrastructure.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-900">2. Software Delivery</h2>
                <h3 className="text-xl font-semibold mb-3 text-gray-900">2.1 Instant Access</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Upon successful subscription or purchase, users receive immediate access to our software platform through:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                  <li>Login credentials sent to registered email address</li>
                  <li>Secure web portal access</li>
                  <li>API keys for integration (where applicable)</li>
                  <li>Mobile application download links (if applicable)</li>
                </ul>

                <h3 className="text-xl font-semibold mb-3 text-gray-900 mt-6">2.2 Enterprise Deployment</h3>
                <p className="text-gray-700 leading-relaxed">
                  For enterprise B2B clients, software deployment includes:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                  <li>Custom onboarding and implementation support</li>
                  <li>Integration with existing healthcare systems</li>
                  <li>Training sessions for staff (virtual or on-site as per agreement)</li>
                  <li>Dedicated account management</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-900">3. Service Exchange Policy</h2>
                <h3 className="text-xl font-semibold mb-3 text-gray-900">3.1 Plan Changes</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Users may exchange or upgrade their subscription plans:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                  <li>Upgrades take effect immediately with pro-rated billing</li>
                  <li>Downgrades take effect at the next billing cycle</li>
                  <li>Feature access adjusts according to the new plan</li>
                  <li>Data and settings are preserved during plan changes</li>
                </ul>

                <h3 className="text-xl font-semibold mb-3 text-gray-900 mt-6">3.2 Module Exchange</h3>
                <p className="text-gray-700 leading-relaxed">
                  For modular subscriptions, users can exchange add-on modules or features subject to:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                  <li>Minimum commitment periods as specified in your plan</li>
                  <li>Compatibility with base subscription tier</li>
                  <li>Availability in your region</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-900">4. Hardware Components (If Applicable)</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  In rare cases where Logy.AI provides hardware components (such as specialized medical devices or sensors) as part of an integrated solution:
                </p>
                
                <h3 className="text-xl font-semibold mb-3 text-gray-900">4.1 Shipping Terms</h3>
                <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                  <li>Shipping costs and methods will be specified in the purchase agreement</li>
                  <li>Delivery timeframes vary by location and product availability</li>
                  <li>Tracking information provided upon shipment</li>
                  <li>Signature may be required for high-value items</li>
                </ul>

                <h3 className="text-xl font-semibold mb-3 text-gray-900 mt-6">4.2 Hardware Exchange</h3>
                <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                  <li>Defective hardware may be exchanged within warranty period</li>
                  <li>Exchange requests must be submitted within 30 days of delivery</li>
                  <li>Original packaging and accessories must be included</li>
                  <li>Return shipping labels provided for approved exchanges</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-900">5. Data Migration and Transfer</h2>
                <p className="text-gray-700 leading-relaxed">
                  When exchanging or upgrading services, we ensure:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                  <li>Seamless data migration between service tiers</li>
                  <li>No loss of historical data during transitions</li>
                  <li>Maintenance of all security and compliance standards</li>
                  <li>Support throughout the migration process</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-900">6. International Considerations</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  For international clients:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                  <li>Software access is subject to local regulations and compliance requirements</li>
                  <li>Data residency options available for select regions</li>
                  <li>Multi-language support where available</li>
                  <li>Regional pricing may apply</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-900">7. Service Level Agreements</h2>
                <p className="text-gray-700 leading-relaxed">
                  Our commitment to service delivery includes:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
                  <li>99.9% uptime guarantee for critical services</li>
                  <li>24/7 technical support for enterprise clients</li>
                  <li>Regular updates and maintenance windows</li>
                  <li>Service credits for any SLA breaches as per agreement</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-900">8. How to Request Service Changes</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  To exchange or modify your services:
                </p>
                <ol className="list-decimal list-inside text-gray-700 space-y-2 ml-4">
                  <li>Log in to your Logy.AI account dashboard</li>
                  <li>Navigate to Subscription Management</li>
                  <li>Select the desired plan or module changes</li>
                  <li>Review and confirm the changes</li>
                  <li>For enterprise clients, contact your account manager directly</li>
                </ol>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-900">9. Support and Assistance</h2>
                <p className="text-gray-700 leading-relaxed">
                  For any questions regarding service delivery or exchanges:
                </p>
                <div className="mt-4 text-gray-700">
                  <p>Email: support@logy.ai</p>
                  <p>Enterprise Support: enterprise@logy.ai</p>
                  <p>Phone: +91-700197-(two zero one six)</p>
                  <p>Support Portal: support.logy.ai</p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold mb-4 text-gray-900">10. Policy Updates</h2>
                <p className="text-gray-700 leading-relaxed">
                  This policy may be updated periodically to reflect changes in our service offerings or delivery methods. Users will be notified of significant changes via email or platform notifications.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}